import React from "react";
import { Col, Container, Row, Accordion } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question:
      "لماذا يجب علي اختيار تيك ريفول دون شركات تصميم تطبيقات الجوال الأخرى في دبي؟",
    answer: ` <p>أحد أهم الأسباب لاختيار تيك ريفول دون شركات تصميم تطبيقات الجوال الأخرى هو أنك ستحصل على خدمات وحلول رقمية شاملة مصممة خصيصًا لاحتياجاتك.</p>
    <p>فنحن شركة تصميم تطبيقات تتمتع بسنوات من الخبرة، ويكرس فريق من المتخصصين لدينا جهوده لإنشاء تطبيقات مبتكرة وآمنة وسهلة الاستخدام والصيانة. يضمن التزامنا بالجودة والتميز حصولك على أفضل تجربة لتطوير التطبيقات.</p>
    <p>وأكثر من ذلك، نحن نقدم خدمات تتمتع بتكلفة اقتصادية، وبذلك ستجني أفضل قيمة مقابل أموالك.</p>
    `,
  },
  {
    question: "هل يمكنك تقديم خدمات تطوير وتصميم تطبيقات لأي أو اس وأندرويد؟",
    answer: `<p>نعم! في شركة تصميم تطبيقات الجوال (تيك ريفول)، لدينا فريق من الخبراء المتخصصين في تطوير التطبيقات لمنصات أي أو اس وأندرويد، لذلك يمكنك التأكد من أنه سيتم تحسين تطبيقك لكلا النظامين الأساسيين.
    اختر تيك ريفول لتلبية احتياجات تطوير وتصميم تطبيقات الجوال الخاصة بك ودعنا نساعدك في رحلة تطبيقك.</p>`,
  },
  {
    question: "لدي فكرة بالفعل - كيف يمكنني بدء رحلة تطبيقي مع تيك ريفول؟",
    answer: ` <p>إذا كانت لديك فكرة لتقديمها، فهذا هو المكان المناسب لبدء رحلة تطوير تطبيقك. للبدء مع تيك ريفول، ما عليك سوى ملء نموذج أو الاتصال بوكلائنا المباشرين. وسيقوم فريق من الخبراء لدينا بالرد على الفور على استفساراتك الخاصة بتطبيقك. سيستمع المتخصصون المهرة لدينا باهتمام إلى جميع أسئلتك ومخاوفك ويقدمون حلولاً فعالة في الوقت المناسب
    </p>`,
  },
  {
    question: "ما هي تكلفة إنشاء تطبيق في دبي؟",
    answer: `<p>تتراوح تكلفة تطوير التطبيقات في المملكة العربية دبي عادة بين 5,000 دولار أمريكي لمعظم التطبيقات الأساسية وبضع مئات الآلاف من الدولارات للمشاريع الأكثر تعقيدًا. وقد تطرأ نفقات إضافية وفقًا لعوامل مختلفة. ومثال على ذلك: ميزات التطبيق والوظائف والتقنيات والميزانية والإطار الزمني المحدد.
    تواصل مع شركة تصميم تطبيقات الجوال (تيك ريفول) اليوم واحصل على مساعدة احترافية لاحتياجات تطوير تطبيقاتك الرقمية.
    </p>
        `,
  },
  {
    question: " كم من الوقت سيستغرق تطبيقي حتى يكتمل؟",
    answer: `<p>بشكل عام، يعتمد الإطار الزمني لتصميم تطبيق للجوال على العديد من العوامل. ومثال على ذلك: نوع التطبيق والجمهور المستهدف والمنصة المراد استخدامها وأدوات التطوير والأطر التي تنوي دمجها وميزانيتك والإطار الزمني المحدد.</p>
    <p>وعادة، يستغرق التطبيق البسيط ذو الميزات والوظائف المحدودة ما بين 2-3 أشهر. وعلى العكس من ذلك، يستغرق التطبيق المعقد حوالي 4-6 أشهر أو أكثر.
    اتصل بنا اليوم ودع المتخصصين لدينا يساعدونك في رحلتك الرقمية</p>`,
  },
];

function FaqLocation({ rtl }) {
  const className = rtl
    ? "faq_loc p-100 tekrevol_dark_bg rtl-style"
    : "faq_loc p-100 tekrevol_dark_bg";
  return (
    <div className={className}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>وها هي أهم الأسئلة الشائعة</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
